import { render, staticRenderFns } from "./CdbCustomerTour.vue?vue&type=template&id=5bc63456&scoped=true&"
import script from "./CdbCustomerTour.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerTour.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerTour.vue?vue&type=style&index=0&id=5bc63456&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc63456",
  null
  
)

export default component.exports